import { useMemo } from "react";
import { parseDate } from "utilities/datetime";
import { useFirestore } from "../useFirestore";
import { pickemsContest } from "../models/pickems";

export const usePickemsContests = () => {
  const { data, isLoading, error } = useFirestore(
    `/pickemsContests`,
    pickemsContest.array(),
    { keyPath: "id" },
  );

  const processedContests = useMemo(() => {
    if (!data) return [];

    return data.map(({ scheduledStartTime, ...contest }) => ({
      ...contest,
      scheduledStartTime: parseDate(scheduledStartTime),
    }));
  }, [data]);

  return { contests: processedContests, isLoading, error } as const;
};

export type PickemsContests = ReturnType<typeof usePickemsContests>["contests"];
